import { createSlice } from "@reduxjs/toolkit";
import getModifiedCreditHospitals from "@custom/rtk-apis/modalityStudyRegion/getModifiedCreditHospitals";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getModifiedCreditHospitalsSlice = createSlice({
  name: "getModifiedCreditHospitalsSlice",
  initialState,
  reducers: {
    closeModal : (state) => {
      state.result = null;
      state.status = "";
      state.msg = "";
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getModifiedCreditHospitals.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getModifiedCreditHospitals.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
      })
      .addCase(getModifiedCreditHospitals.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getModifiedCreditHospitalsSlice.reducer;
export const { closeModal } = getModifiedCreditHospitalsSlice.actions;
